import Settings from './settings';
import AWS from 'aws-sdk';
import axios from 'axios';

AWS.config.region = 'ap-northeast-1';
AWS.config.credentials = new AWS.CognitoIdentityCredentials({IdentityPoolId: Settings.S3.IdentityPoolId});
console.log('AWS.config.credentials', AWS.config.credentials);
const s3 = new AWS.S3;

export let putJSON = (data) => {
  console.log('Settings', Settings);
  s3.putObject({
    Bucket: Settings.S3.Bucket,
    Key: Settings.S3.Key,
    Body: JSON.stringify(data),
    ContentType: "application/json"},
    (err,data) => {
      console.log(JSON.stringify(err) + " " + JSON.stringify(data));
    }
  );
}

export let readJSON = async () => {
  return axios('https://s3-ap-northeast-1.amazonaws.com/bms.viatick.com/api-tracking.json', {
    headers : {
      'Access-Control-Allow-Origin': '*'
    }
  });
}
